export default __webpack_public_path__ + "static/tbzgJkJi-ea3158513b7da7c8737d874d01f4113a.svg";